module.exports = __webpack_public_path__ + "media/images/pages/fig_gourmet_02-67bb209684fb39017e1168806b90f411.png";